<p-dialog
  [visible]="visible"
  (visibleChange)="visible = $event"
  [header]="confirmDialogHeader()"
  [modal]="true"
  [style]="{width: '450px'}"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  (onHide)="cancelAction()"
  [closable]="true"
>
  <div class="dialog-content">
    <div class="flex align-items-center mb-3">
      <i class="pi pi-exclamation-triangle mr-2" style="font-size: 1.5rem; color: var(--yellow-500);"></i>
      <p>{{ confirmDialogMessage() }}</p>
    </div>

    @if (shouldShowReason()) {
      <div class="field mt-4">
        <label for="reason" class="block font-medium mb-2">
          Motivul acțiunii: <span class="text-sm text-gray-500">(opțional)</span>
        </label>
        <textarea
        id="reason"
        pInputTextarea
        [ngModel]="actionReason()"
        (ngModelChange)="updateReason($event)"
        rows="3"
        class="w-full"
        placeholder="Introduceți motivul pentru această acțiune (opțional)..."
        ></textarea>
      </div>
    }
  </div>

  <p>Pentru a continua, va rugam sa tastati "{{ SECURITY_KEYWORD() }}" in campul de mai jos</p>
  <input
    pInputText
    [(ngModel)]="securityKeywordControl"
    class="w-full"
  >

  <ng-template pTemplate="footer">
    <p-button
      data-testid="dialog-secondary"
      label="Nu"
      icon="pi pi-times"
      styleClass="p-button-text"
      (click)="cancelAction()"
    ></p-button>
    <p-button
      data-testid="dialog-primary"
      label="Da"
      icon="pi pi-check"
      [disabled]="!canProceed()"
      (click)="confirmActionWithReason()"
    ></p-button>
  </ng-template>
</p-dialog>